import {
  IsNumber,
  IsNumberString,
  MaxLength,
  MinLength
} from 'class-validator';

/**
 * Validation request for checking if employee has operator access to Cost Centre.
 */
export class PosValidateOperatorPinRequestForCostCentreDto {
  /**
   * Employee POS Access Pin
   */
  @IsNumberString()
  @MinLength(2)
  @MaxLength(8)
  public posAccessPin: string;

  /**
   * 
   * Cost Centre Id
   */
  @IsNumber()
  public costCentreId: number;

  constructor(posAccessPin: string, costCentreId: number) {
    this.posAccessPin = posAccessPin;
    this.costCentreId = costCentreId;
  }
}
